import {StartScreenModule} from '@fantasmagames/slot/src/modules/startscreen/StartScreenModule';

export class GameStartScreenModule extends StartScreenModule {

	protected keyboardInput(event: KeyboardEvent): void {
		if (event.code === 'Space' || event.code === 'Enter') {
			this.view.proceed();
		}

		if (event.code === 'KeyA' || event.code === 'ArrowLeft') {
			this.view.nextFeature();
		}

		if (event.code === 'KeyD' || event.code === 'ArrowRight') {
			this.view.previousFeature();
		}
	}
}


// WEBPACK FOOTER //
// ./src/startscreen/GameStartScreenModule.ts